import { useEffect } from 'react';

import { createTraceParameters, getAppLogger } from '@tgg/util';

import { applicationIdentifier } from 'apps/commerce/core/constants';

export const useHandleScriptErrors = () => {
    useEffect(() => {
        const baseErrorHandler = window.onerror;
        const appLogger = getAppLogger({
            applicationIdentifier,
        });

        // eslint-disable-next-line unicorn/prefer-add-event-listener
        window.onerror = function (message, source, lineno, colno, error) {
            const errorData = {
                message,
                error,
                sourceInfo: {
                    source,
                    lineno,
                    colno,
                },
            };

            appLogger.error(`Script error: ${message}`, {
                ...createTraceParameters({
                    context: null,
                    parameters: {
                        operation: `global-error-handler`,
                    },
                }),
                ...errorData,
            });
        };

        return () => {
            // eslint-disable-next-line unicorn/prefer-add-event-listener
            window.onerror = baseErrorHandler; // Clean up on unmount
        };
    }, []);
};
